import { render } from "./HeroiconsSolidViewGrid.vue?vue&type=template&id=905138be"
const script = {}

import exportComponent from "/home/tobias/Desktop/screenads/nova-custom2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidViewGrid.vue"]])

export default __exports__